module.exports = app => {
  const routes = [];
  return routes;
};
